import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";

import TeamIcon from "@components/icons/TeamIcon";
import { formatTeamName } from "@utils/format/formatter";
import { BettingTips } from "@api-types/bet-booster/BettingTipsType";

export default observer(function BettingTipsTeams(props: {
	data: BettingTips;
}) {
	const containerClassName = classNames("card--qp__event card--bbt__event");

	const competitorClassName = classNames(
		"card--qp__competitor card--bbt__competitor card--qp--nowrap__competitor card--bbt--nowrap__competitor"
	);

	const iconClassName = classNames("card--qp__icon u-icon u-icon--base");

	const teamNameClassName = classNames(
		"card--bbt__team card--bbt--nowrap__team"
	);

	return (
		<div className={containerClassName}>
			<div className={competitorClassName}>
				<TeamIcon
					showCountryFlag={props.data.sportData?.showCountryFlag ?? false}
					flagCode={props.data.sportData?.teamOneCountryCode}
					jerseyTypeAbrv={props.data.sportData?.teamOneJerseyTypeAbrv}
					opponentFlagCode={props.data.sportData?.teamTwoCountryCode}
					opponentJerseyTypeAbrv={props.data.sportData?.teamTwoJerseyTypeAbrv}
					className={iconClassName}
				/>
				<span className={teamNameClassName}>
					{formatTeamName(
						props.data.sportData?.teamOneName,
						props.data.sportData?.teamOneGender,
						props.data.sportData?.eventType
					)}
				</span>
			</div>
			<div className={competitorClassName}>
				<TeamIcon
					showCountryFlag={props.data.sportData?.showCountryFlag ?? false}
					flagCode={props.data.sportData?.teamTwoCountryCode}
					jerseyTypeAbrv={props.data.sportData?.teamTwoJerseyTypeAbrv}
					opponentFlagCode={props.data.sportData?.teamOneCountryCode}
					opponentJerseyTypeAbrv={props.data.sportData?.teamOneJerseyTypeAbrv}
					className={iconClassName}
				/>
				<span className={teamNameClassName}>
					{formatTeamName(
						props.data.sportData?.teamTwoName,
						props.data.sportData?.teamTwoGender,
						props.data.sportData.eventType
					)}
				</span>
			</div>
		</div>
	);
});
